import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import { isBoolean } from "lodash";
import HoverImage from "react-hover-image/build";
import ReactStrapTable from "components/reactStrapTable";
import DownloadIcon from "assets/icon/icon-icon-options-download.svg";
import DownloadIconHover from "assets/icon/icon-icon-options-download_hover.svg";
import Drawer from "components/Drawer";
import useAxios from "hooks/useAxios";
import { onExport } from 'utils/helper';
import { ModuleAccess } from "utils/moduleaccess";
import {
  cellRendererCheck,
  dateFormate,
  currencyFormat,
} from "utils/columns";
let tableDataBackup = [];
let autoselectlist1 = [];
let hideColFilterlist = ['PO Date', 'Total Ordered Price', 'PO Number', 'Source PO#',]
let currencylist = ['Total Ordered Price', 'Total Invoiced Price']
let numberlist = ['PO Number', 'Source PO#', 'Total Packages Ordered', 'Total Ordered Price', 'Total Invoiced Packages']
let dateList = ['PO Date',]

const InvoiceTable = ({tenantID, data, loading, onExport, filters, totalSize, onPageChange, refetch, setLoading, onSearchColumnFilters, reset,toggleSider,
  collapseSider,}) => {
  const API = useAxios();
  const [hasExportPermission, setHasExportPermission] = useState(false);
  const [tableData, setTableData] = useState(tableDataBackup);

  tableDataBackup = data;
  const [state, updateState] = useState({
    isOpen: false,
    invoiceID: "",
    invoice: {},
    tableData: [],
    backUpData: [],
    filters: filters,
  });

  useEffect(() => {
      setState({ tableData: data, backUpData: data });
    }, [data]);
    const setState = (obj) => updateState(pre => ({ ...pre, ...obj }));
  
    useEffect(() => {
      setState({ filters: filters });
    }, [filters]);

    const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
      if (hasColFilter) {
        setState({
          filters: filter,
        });
        let colFilterOn = { ...filter, filters: colChangedFilter };
        return onPageChange(colFilterOn, true);
      }
      setState({
        filters: filter,
      });
      onPageChange(filter);
    };
  
    const handleFilterCancel = () => {
      refetch();
    };

    const handleSearchColumnFilters = (colFilter) => {
      if (onSearchColumnFilters) {
        const filter = { ...state.filters, filters: colFilter, currentPage: 1 };
        onSearchColumnFilters(filter);
        setState({
          filters: filter,
        });
      }
    };

    const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
      if (hasColFilter) {
        setState({
          filters: filter,
        });
        let colFilterOn = { ...filter, filters: colChangedFilter };
        onPageChange(colFilterOn, true);
      } else {
        setState({
          filters: filter,
        });
        onPageChange(filter);
      }
    };

    const handleSort = (filter, hasColFilter) => {
      setState({
        filters: filter,
      });
      if (hasColFilter) {
        onPageChange(filter, true);
      } else {
        onPageChange(filter);
      }
    };

  const download = async (invId) => {
    try {
      const { access_token } =
        JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
      const res = await API.get(
        `/${tenantID}/Invoice/Download/${parseInt(
          invId
        )}?access_token=${access_token}`,
        {
          responseType: "blob",
        }
      );

      if (res.request.responseType === "blob") {
        window.open(res.request.responseURL);
      }
    } catch (error) { }
  };

  const previewInvoice = (invoice) => {
    if (invoice.invoiceStatusID === 230003) {
      return (
        <div className="text-center">
          <Button
            color="link"
            className="text-primary p-0 text-decoration-none"
            onClick={() => download(invoice.invoiceID)}
            title="Download"
            hidden={!ModuleAccess("INVOICE", "INVD")}
          >
            <HoverImage
              key="DownloadIcon"
              src={DownloadIcon}
              hoverSrc={DownloadIconHover}
              alt=""
            />
          </Button>
        </div>
      );
    }
  };

  let columns = [
   {
      dataField: "edit",
      text: "Options",
      width: 90,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
      cellRenderer: (row) => previewInvoice(row),
    },
    {
      dataField: "coveredEntityName",
      text: "Covered Entity/OPAID",
      sort: false,
      width: 260,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.coveredEntityName),
    },

    {
      dataField: "chainPharmacyName",
      text: "Chain Pharmacy",
      sort: false,
      width: 200,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.chainPharmacyName),
    },

    {
      dataField: "createdDate",
      text: "Invoiced Date",
      sort: false,
      width: 144,
      show: true,
      inputType: "date",
      hideColFilter: true,
      cellRenderer: (row) => dateFormate(row.createdDate),
    },
    {
      dataField: "InvGenerationNumber",
      text: "Invoice Number",
      sort: true,
      width: 144,
      show: true,
      inputType: "number",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.invoiceNumber),
    },
    {
      dataField: "invoiceDateRange",
      text: "Date Range",
      sort: false,
      width: 150,
      show: true,
      inputType: "date",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.invoiceDateRange),
    },
    {
      dataField: "claimsCount",
      text: "Claims Count",
      sort: true,
      width: 144,
      show: true,
      inputType: "number",
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.claimsCount),
    },
    {
      dataField: "grossRevenue",
      text: "Total Paid",
      sort: true,
      width: 144,
      show: true,
      inputType: "number",
      hideColFilter: false,
      cellRenderer: (row) => currencyFormat(row.grossRevenue),
    },
    {
      dataField: "dispensingFee",
      text: "Dispensing Fee",
      sort: true,
      width: 144,
      show: true,
      inputType: "number",
      hideColFilter: false,
      cellRenderer: (row) => currencyFormat(row.dispensingFee),
    },
    {
      dataField: "amountDue",
      text: "Amount Due",
      sort: true,
      width: 144,
      show: true,
      inputType: "number",
      hideColFilter: false,
      cellRenderer: (row) => currencyFormat(row.amountDue),
    },
  ];
  
  
  useEffect(() => {
    setHasExportPermission(ModuleAccess("INVOICE", "EXP"));
  }, []);

  const handleselectColoums = () => {
    setColoumselect(!coloumselect);
  }
  useEffect(() => {
    setTableData(data);
    tableDataBackup = data;
  }, [data]);

  const hasPermission = (code) => {
    return ModuleAccess("Invoice", code);
  };
  
  const { filters: colFilter, backUpData } = state;

  return (
    <div>
    <h5 className="f-16 text-primary font-weight-700">
      Invoice Count ({totalSize})
    </h5>
    <hr />
      <div
        className='table-card scroll-table position-relative border-0 rounded pt-0'
        fixed-height={tableData.length > 0 ? "fixed-height" : "default"}
      >
        
        <ReactStrapTable
          id='inventory-table'
          fixedColumn
          data={backUpData}
          // loading={loading}
          columns={columns}
          onPageSizeChange={onPageSizeChange}
          pageSize={colFilter.pageSize}
          onExport={onExport}
          hasPagination
          onPageChange={onHandlePageChange}
          currentPage={colFilter.currentPage}
          totalRecords={totalSize}
          handleSort={handleSort}
          filters={colFilter}
          onFilterCancel={handleFilterCancel}
          onSearchColumnFilters={handleSearchColumnFilters}
          hasExportPermission={hasExportPermission}
               collapseSider={collapseSider}
        enabletogglesider={true}
        toggleSider={toggleSider}
        >
        </ReactStrapTable>
      </div>
    </div>
  );
};

export default InvoiceTable;
